import { useCallback } from 'react';

// Mapeia a category legada para um event_name GA4 descritivo.
// O event_name resolve o P1 (todos os eventos chegavam como 'click').
// Os params event_category e event_label são mantidos para backward compat (P2).
const CATEGORY_TO_EVENT = {
  navigation:   'navigation_click',
  cta:          'cta_click',
  filter:       'filter_change',
  download:     'file_download',
  interaction:  'content_interaction',
  shortcut:     'shortcut_click',
  wallet:       'wallet_click',
};

export const useGA = () => {
  const trackEvent = useCallback((eventName, parameters = {}) => {
    if (window.gtag) {
      window.gtag('event', eventName, parameters);
    }
  }, []);

  const trackPageView = useCallback((pageTitle, pageLocation, pagePath) => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: pageTitle,
        page_location: pageLocation,
        ...(pagePath && { page_path: pagePath }),
      });
    }
  }, []);

  const trackUserAction = useCallback((action, category, label = null, value = null) => {
    if (window.gtag) {
      const eventName = CATEGORY_TO_EVENT[category] || action;
      const eventParams = {
        event_category: category,
        event_label: label,
      };

      if (value !== null) {
        eventParams.value = value;
      }

      window.gtag('event', eventName, eventParams);
    }
  }, []);

  return {
    trackEvent,
    trackPageView,
    trackUserAction,
  };
};
